import { render, staticRenderFns } from "./AddDiscount.vue?vue&type=template&id=62c3f9ed&scoped=true&"
import script from "./AddDiscount.vue?vue&type=script&lang=js&"
export * from "./AddDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c3f9ed",
  null
  
)

export default component.exports